module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_yn-6d786a04ae68000b7921da2f4e06a96e.png";